module.exports = __webpack_public_path__ + "static/media/lens.af96a27c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lens.svg
// module id = 347
// module chunks = 0